import React from 'react';

import styles from './Box.scss';
import { PageTitle, Steps } from 'components'



const Box = (props) => {
  let classNames = styles.wrapper;

  if(props.align == 'center'){
    classNames = classNames + ' ' + styles.isCentered
  }


  return (
  	<div className={classNames}>
  	    {props.children}
		</div>
	)
}


export default Box


// WEBPACK FOOTER //
// ./src/components/organisms/Box/index.js